import { render } from "./appMenu.vue?vue&type=template&id=1043d963&scoped=true&lang=pug"
import script from "./appMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./appMenu.vue?vue&type=script&setup=true&lang=js"

import "./appMenu.vue?vue&type=style&index=0&id=1043d963&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1043d963"]])

export default __exports__